import { render, staticRenderFns } from "./WeChatPayPage.vue?vue&type=template&id=4dbeb1e1&"
import script from "./WeChatPayPage.vue?vue&type=script&lang=js&"
export * from "./WeChatPayPage.vue?vue&type=script&lang=js&"
import style0 from "./WeChatPayPage.vue?vue&type=style&index=0&id=4dbeb1e1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports